export type UserLike = {
  id: string;
  name?: string | null;
  email?: string | null;
};

export type UserDisplayNameSource = "name" | "email" | "id";

export type ResolveUserDisplayNameResult = {
  value: string;
  source: UserDisplayNameSource;
};

function normalizeString(value?: string | null) {
  const normalized = value?.trim();
  return normalized ? normalized : null;
}

function getFirstToken(value: string) {
  return value.split(/\s+/)[0] || value;
}

export function resolveUserDisplayName(
  user: UserLike,
  options?: {
    onlyFirstName?: boolean;
  },
): ResolveUserDisplayNameResult {
  const resolvedName = normalizeString(user.name);
  const emailLocalPart = normalizeString(user.email)?.split("@")[0] ?? null;
  const source: UserDisplayNameSource = resolvedName
    ? "name"
    : emailLocalPart
      ? "email"
      : "id";
  const fullValue = resolvedName ?? emailLocalPart ?? user.id;

  return {
    value: options?.onlyFirstName ? getFirstToken(fullValue) : fullValue,
    source,
  };
}
